<div class="flex flex-col gap-3 p-4 rounded-lg border border-red-600">
  <div class="flex flex-row items-center gap-2">
    <fa-icon [icon]="faTrashCan" class="text-sm text-red-600 shrink-0"></fa-icon>
    <span class="text-sm font-medium flex-1 truncate text-gray-500 line-through">{{ itemName }}</span>
    <app-proposal-status-badge class="shrink-0" status="removed"></app-proposal-status-badge>
  </div>
  <p class="text-sm text-gray-700">
    chatBIC schlägt vor, diese {{ itemLabel }} zu löschen.
  </p>
  <div class="flex flex-row items-center justify-end">
    <app-proposal-actions (acceptClicked)="removeClicked.emit()"
                          (rejectClicked)="restoreClicked.emit()"
                          acceptLabel="Löschen übernehmen"
                          rejectLabel="Behalten"></app-proposal-actions>
  </div>
</div>
